[...document.querySelectorAll("a[href^='#']")].forEach((a) =>
  a.addEventListener("click", (event: Event) => {
    const element = event.target as HTMLAnchorElement;
    if (
      element.hash.length != 0 &&
      (window.location.pathname.replace(/^\//, "") == element.pathname.replace(/^\//, "") ||
        window.location.hostname == element.hostname)
    ) {
      const target = document.querySelector(element.hash);
      if (target == null || !target.classList.contains("anchor")) {
        return;
      }
      const headerHeight = document.getElementById("header")?.clientHeight ?? 0;
      const offset = target.getBoundingClientRect().top;
      const finalPosition = offset - headerHeight;
      console.log(target, offset, headerHeight, finalPosition);
      window.scrollBy({ top: finalPosition, behavior: "smooth" });
      event.preventDefault();
    }
  })
);
